import { TornaEnrereProps } from './TornaEnrere.types';
// @ts-ignore
import Icona from 'components/corporatiu/ui/Icona';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac';
const Enllac: any = EnllacComponent;
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './tornaEnrere.module.scss';

const TornaEnrere = (props: Readonly<TornaEnrereProps>) => {
    const { path, estil, text = 'Torna enrere', isBlanc = false } = props;
    const stylesTornaEnrere = clsx(styles.breadcrumb, estil && styles[estil]);

    return (
        <Enllac href={path} className={stylesTornaEnrere}>
            <Icona icona='fletxa_simple_esquerra' path='corporatiu' className={styles.icona} mida={32} isBlanc={isBlanc} />
            <span className={styles.text}>{text}</span>
        </Enllac>
    );
};

export default TornaEnrere;
